import { RowContainer } from 'components/Layout';
import { useMemo } from 'react';
import { convertTicksToMinutes, formatTime, formatTimeWithoutAmOrPm, useFormatDate } from 'utils/dateTimeUtils';
import styles from './filterItem.module.scss';
import { formatFilterOperation } from './filterItemHelper';
import { getFormatedId } from 'utils/commonHelper';
import { MapItem, convertToAbsoluteName, getSelectedItem } from 'components/Form/controls/MapPicker/MapPicker/helpers';
import { BooleanColumnModel, CurrencyColumnModel, DateColumnModel, DateTimeColumnModel, DurationColumnModel, FilterType, FormattedReferenceColumnModel, GenericColumnModel, MapOptionColumnModel, NumberColumnModel, OptionColumnModel, OptionsColumnModel, RemoteOptionColumnModel, RemoteOptionsColumnModel, StringColumnModel, TextareaColumnModel, TimeColumnModel } from '../../models';
import { Translation } from 'components/Translations/Translation';

type Props = {
	filter: FilterType
	columns: GenericColumnModel[]
}

export const FilterItem = ({ filter, columns }: Props) => {
	const formatDate = useFormatDate();

	const filterItemMemo = useMemo(
		() => {
			const column = columns.find((column) => column.id === filter.columnId);
			if (!column) {
				return {};
			}

			let value = '';

			if (column instanceof OptionColumnModel || column instanceof OptionsColumnModel || column instanceof RemoteOptionColumnModel || column instanceof RemoteOptionsColumnModel) {
				const { items, getItemId, getItemText } = column;
				for (const option of items) {
					const optionId = getItemId && getItemId(option);
					if (optionId === filter.value) {
						value = getItemText ? getItemText(option) : filter.value;
						break;
					}
				}
			} else if (column instanceof MapOptionColumnModel) {
				const options = column.items as MapItem[] || [];
				const selectedOption = getSelectedItem(filter.value, options);
				if (selectedOption) {
					value = convertToAbsoluteName(selectedOption, options);
				}
			} else if (column instanceof DateColumnModel || column instanceof DateTimeColumnModel) {
				value = formatDate(new Date(filter.value));
			} else if (column instanceof TimeColumnModel) {
				const { isDuration } = column;
				value = isDuration ? formatTimeWithoutAmOrPm(filter.value) : formatTime(filter.value);
			} else if (column instanceof FormattedReferenceColumnModel) {
				const { entityPrefix } = column;
				value = entityPrefix ? getFormatedId(entityPrefix, filter.value) : `${filter.value}`;
			} else if (column instanceof BooleanColumnModel) {
				value = String(filter.value)
			} else if (column instanceof NumberColumnModel || column instanceof CurrencyColumnModel || column instanceof StringColumnModel || column instanceof TextareaColumnModel || column instanceof DurationColumnModel) {
				value = column instanceof DurationColumnModel ? `${convertTicksToMinutes(filter.value)} min` : `${filter.value}`;
			} else {
				value = filter.value;
			}
			return {
				title: column.title,
				value
			}
		},
		[columns, filter, formatDate]
	)

	return (
		<span className={styles.item}>
			<RowContainer margin='xsmall' wrap='nowrap'>
				<Translation i18n={filterItemMemo.title} />
				<span className={styles.operation}>
					<Translation i18n={formatFilterOperation(filter.operation)} />
				</span>
				<span><Translation i18n={filterItemMemo.value} /></span>
				{/* da li dodati delete, tipa na hover da se pojavi neki 'X' */}
				{/* <span className={styles.delete_button} onClick={deleteCallback}>X</span> */}
			</RowContainer>
		</span>
	)
}
